import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { GetStakingRewardTransactionsQuery } from "@gql/staking";
import { StakingRewardsState } from "@modules/staking/domain/entities/staking-rewards-state.model";
import { Tradable } from "@models/interfaces/tradable";
import { StakingRewardTransaction } from "@modules/staking/domain/entities/staking-reward-transaction.model";
import { TradableListService } from "@main-services/currency/tradable_list.service";

export class StakingRewardTransactionAdapter extends BaseAdapter<
	GetStakingRewardTransactionsQuery,
	StakingRewardsState
> {
	public constructor(public tradableListService: TradableListService) {
		super();
	}

	public adapt(item: GetStakingRewardTransactionsQuery): StakingRewardsState {
		return {
			init: true,
			hasError: false,
			rewardTransactions: item.history.map((rewardItem) => {
				const tradable: Tradable = this.tradableListService.getItemById(rewardItem.asset.assetId);
				return {
					assetId: tradable.getId(),
					assetName: tradable.getName(),
					assetSymbol: tradable.getSymbol(),
					assetAmount: rewardItem.assetAmount.value,
					payoutDateIso: rewardItem.createdAt.iso8601,
					tax: rewardItem?.tax
				} as StakingRewardTransaction;
			})
		};
	}
}
